import { render } from "./ExperienceForm.vue?vue&type=template&id=1a20f9e3"
import script from "./ExperienceForm.vue?vue&type=script&lang=js"
export * from "./ExperienceForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__